import React from "react";
import { Link } from "react-router-dom";
import { Card, Alert } from "react-bootstrap";
import routeNames from "../../router/routeNames";
import AppButton from "../components/Common/AppButton";

const ExternalLoginFailed = () => {
  return (
    <div className="my-5">
      <div className="text-center mb-4">
        <Alert variant="warning" className="border-0 bg-light">
          <div className="text-center">
            <h5 className="text-warning mb-3">
              <i className="fas fa-info-circle me-2"></i>
              Unable to Complete Login
            </h5>

            <div className="alert alert-info border-0 bg-primary bg-opacity-10">
              <strong>Need Help?</strong>
              <br />
              If you believe you should have access to this system, please
              contact your administrator.
            </div>
          </div>
        </Alert>

        <div className="text-center mt-4">
          <Link to={routeNames.login}>
            <AppButton
              type="button"
              title="Back to Login"
              buttonSize="lg"
              variant="back"
              className="me-2"
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ExternalLoginFailed;
